import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory, useNavigate } from "react-router-dom";



const ProjectsFilterPage = () => {
    const [departments, setDepartments] = useState([]);
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [selectedDeptId, setSelectedDeptId] = useState('');
    const [selectedProjectType, setSelectedProjectType] = useState('');
    const [startYear, setStartYear] = useState('');
    const [endYear, setEndYear] = useState('');
    const [error, setError] = useState(null);
    const navigate = useHistory();
    
    // Fetch departments
    useEffect(() => {
        const getDepartments = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/departments`);
                setDepartments(response.data);
            } catch (error) {
                console.error("Error fetching departments:", error);
                setError("Failed to fetch departments.");
            }
        };
        getDepartments();
    }, []);

    // Fetch all projects initially
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects/filter`)
            .then(response => {
                setProjects(response.data);
                setFilteredProjects(response.data);
            })
            .catch(error => {
                console.error("Error fetching all projects:", error);
            });
    }, []);

    // Handle Reset Button Click
    const handleReset = () => {
        setSelectedDeptId('');
        setSelectedProjectType('');
        setStartYear('');
        setEndYear('');
        setFilteredProjects(projects); // Reset to full project list
    };

    // Handle filter logic
    const handleFilter = () => {
        const params = {};
        if (selectedDeptId) params.deptId = selectedDeptId;
        if (selectedProjectType) params.projType = selectedProjectType;
        if (startYear) params.startYear = parseInt(startYear);
        if (endYear) params.endYear = parseInt(endYear);

        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects/filter`, { params })
            .then(response => {
                setFilteredProjects(response.data);
            })
            .catch(error => {
                console.error("Error fetching filtered projects:", error);
            });
    };

    return (
        <div className="d-flex gap-3">
    

    <div className="col-md-3 border p-3 rounded bg-light">
        <h5>Filter Options For Projects</h5>
        
        {/* Filter by Department */}
        <div className="mb-3">
            <label htmlFor="department" className="form-label">Filter by Department</label>
            <select
                id="department"
                className="form-select"
                value={selectedDeptId}
                onChange={(e) => setSelectedDeptId(e.target.value)}
            >
                <option value="">All Departments</option>
                {departments.map((dept) => (
                    <option key={dept.deptId} value={dept.deptId}>{dept.deptName}</option>
                ))}
            </select>
        </div>

        {/* Filter by Start Year */}
        <div className="mb-3">
            <label htmlFor="startYear" className="form-label">Filter by Start Year</label>
            <input
                type="number"
                id="startYear"
                className="form-control"
                value={startYear}
                onChange={(e) => setStartYear(e.target.value)}
            />
        </div>

        {/* Filter by End Year */}
        <div className="mb-3">
            <label htmlFor="endYear" className="form-label">Filter by End Year</label>
            <input
                type="number"
                id="endYear"
                className="form-control"
                value={endYear}
                onChange={(e) => setEndYear(e.target.value)}
            />
        </div>

        {/* Filter by Project Type */}
        <div className="mb-3">
            <label htmlFor="projectType" className="form-label">Filter by Project Type</label>
            <select
                id="projectType"
                className="form-select"
                value={selectedProjectType}
                onChange={(e) => setSelectedProjectType(e.target.value)}
            >   
                <option value="">All Project Types</option>
                <option value="Externally Funded">Externally Funded</option>
                            <option value="Internally Funded">Internally Funded</option>
                            <option value="Consultancy">Consultancy</option>
                            <option value="Funded Programme">Funded Programme</option>
            </select>
        </div>

        {/* Buttons */}
        <button className="btn btn-primary me-2" onClick={handleFilter}>Apply Filters</button>
        <button className="btn btn-secondary" onClick={handleReset}>Reset</button>
    </div>

    {/* Table Section */}
    <div className="col-md-9">
        <div className="table-responsive border rounded">
            <table className="table table-striped table-bordered rounded">
                <thead className="table-dark">
                    <tr>
                        <th>Project ID</th>
                        <th>Project Type</th>
                        <th>Title</th>
                        {/*<th>TRL Level</th>*/}
                        <th>Keyword</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredProjects.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="text-center">No Records Found</td>
                        </tr>
                    ) : (
                        filteredProjects.map((obj, index) => (
                            <tr key={index}>
                                <td>{obj.projId}</td>
                                <td>{obj.projType}</td>
                                <td>{obj.projTitle}</td>
                               {/* <td>{obj.trlLevel}</td> */} 
                                <td>{obj.projKeyword}</td>
                                <td>
                                <button 
                                        className="btn btn-primary" 
                                        onClick={() => navigate.push(`/viewproject/${obj.projId}`)}
                                    >
                                        View Details
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    </div>
</div>

    );
};

export default ProjectsFilterPage;